export const featureFlipping = {
  admin: true,
  manage_clients: false,
  manage_users: true,
  manage_api: false,
  consumption_tracking: true,
};
